<template>
  <ul class="flex items-center gap-6">
    <li v-for="social in socials" :key="social.type">
      <CustomNuxtLink
        :to="social.url"
        variant="caption"
        class="transition-all duration-300 ease-out hover:opacity-90 theme:text-primary-100 theme:hover:text-primary-90 flex items-center justify-center w-5 h-5"
        :class="{ 'text-white': variant === 'light', 'text-primary-100': variant === 'dark' }"
        :aria-label="social.type">
        <YoutubeIcon v-if="social.type === 'youtube'" class="h-[18px] w-auto hover:text-community-work-100" />
        <FacebookIcon v-if="social.type === 'facebook'" class="h-[18px] w-auto hover:text-youth-support-100" />
        <InstagramIcon v-if="social.type === 'instagram'" class="h-[18px] w-auto hover:text-[#fc01d8]" />
        <LinkedInIcon v-if="social.type === 'linkedin'" class="h-[18px] w-auto hover:text-[#0b66c3]" />
      </CustomNuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { FacebookIcon, InstagramIcon, YoutubeIcon, LinkedInIcon } from '@gro-up/ui/icons'
import { CustomNuxtLink } from '@gro-up/ui/primitives'

// Note: when using variant 'currentColor', make sure to set the text color on the parent component, as the icons will inherit the color via currentColor
export type FooterSocialProps = {
  socials: {
    type: string
    url: string
  }[]
  variant?: 'light' | 'dark' | 'currentColor'
}

const { variant = 'light' } = defineProps<FooterSocialProps>()
</script>

